const constants = {
    'mapboxToken': 'pk.eyJ1IjoiZ2FzdG9ubHVpc2JsYW5jbyIsImEiOiJjbDhkYmcxcmswMnlsM290Zjl1YXZnaDRhIn0.rjIouo3qMx__wvQ5_5Fu7Q'
}

export default constants;